import axios from 'axios'
import {SET_BRANDS, SET_LOADING, SET_MODELS, SET_MODEL_LOADING, TOGGLE_BRAND_DETAILS} from './types'

export const actions = {
    fetchBrands({commit}) {
        commit(SET_LOADING, true)
        return axios.get('/assets/brands')
            .then(response => commit(SET_BRANDS, response.data.vehicle_brands))
            .finally(() => commit(SET_LOADING, false))
    },
    toggleDetails({commit, dispatch}, brand) {
        commit('TOGGLE_BRAND_DETAILS', brand.id)
        if (brand._showDetails && !brand.models) {
            dispatch('fetchBrandModels', brand.id)
                .catch(() => dispatch('showError', 'Error loading models'))
        }
    },
    fetchBrandModels({commit}, brandId) {
        commit(SET_MODEL_LOADING, {brandId, value: true})
        return axios.get(`/assets/brands/${brandId}/models`)
            .then(response => commit(SET_MODELS, {brandId, models: response.data.vehicle_models}))
            .finally(() => commit(SET_MODEL_LOADING, {brandId, value: false}))
    },

    saveBrand({dispatch}, {brand, brandData}) {
        return (brand.id
            ? axios.put(`/assets/brands/${brand.id}`, brandData)
            : axios.post('/assets/brands', brandData))
            .then(() => dispatch('fetchBrands'))
    },

    deleteBrand({dispatch}, brandId) {
        return axios.delete(`/assets/brands/${brandId}`)
            .then(() => dispatch('fetchBrands'))
    },

    saveModel({dispatch}, {brandId, modelId, modelData}) {
        return (modelId
            ? axios.put(`/assets/brands/${brandId}/models/${modelId}`, modelData)
            : axios.post(`/assets/brands/${brandId}/models`, modelData))
            .then(() => dispatch('fetchBrandModels', brandId))
    },

    deleteModel({dispatch}, {brandId, modelId}) {
        return axios.delete(`/assets/brands/${brandId}/models/${modelId}`)
            .then(() => dispatch('fetchBrandModels', brandId))
    }
}
